const getChainType = async (fieldId, db, chainTypeCache) => {
  if (chainTypeCache.has(fieldId)) return chainTypeCache.get(fieldId)
  const snap = await db.collection('Synchronisations')
    .where('Question', '==', fieldId)
    .where('Type', 'in', ['Question', 'MSIEffect'])
    .limit(1)
    .get()
  const t = snap.empty ? 'Question' : snap.docs[0].data().Type
  chainTypeCache.set(fieldId, t)
  return t
}

export default getChainType;